import { I18n } from 'aws-amplify';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'Payment' })
export class PaymentPipe implements PipeTransform {
  transform(number: number | null | undefined) {
    if (!number || number == 0) {
      return '-';
    } else {
      return Math.round(number * 100) / 100;
    }
  }
}
